import React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionDetails, AccordionSummary, List } from '@mui/material';
import { theme, Icon } from '../../../../../ui';
import { DragHandle, MenuButton } from './EditControls';

const StyledAccordion = styled(Accordion)`
  margin: 0 !important;
  padding-bottom: 0 !important;
  box-shadow: none !important;
  border: none !important;
  pointer-events: ${({ $isLocked, $isMoving }) => ($isLocked || $isMoving ? 'none' : 'auto')};
  background-color: ${({ $active, $lightColor }) => ($active ? $lightColor : theme.colors.NEU_0)} !important;

  &:before {
    background-color: transparent !important;
  }

  .MuiAccordionSummary-content {
    display: flex;
    align-items: center;
    background: transparent !important;
    &.Mui-expanded {
      margin: 16px 0 0 !important;
    }
  }

  .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
    min-height: 0px !important;
  }

  .MuiAccordionDetails-root {
    padding: 0;
  }

  p {
    width: 100%;
  }

  /* Prevent lock icon rotation when section is expanded but locked */
  &.Mui-expanded[data-locked='true'] .MuiAccordionSummary-expandIconWrapper {
    transform: none !important;
  }
`;

const PageList = styled(List)`
  padding: 0 0 12px !important;
  max-height: ${({ $isCollapsed }) => ($isCollapsed ? '0' : '2000px')};
  overflow: hidden;
  opacity: ${({ $isCollapsed }) => ($isCollapsed ? '0' : '1')};
  transition:
    max-height 0.3s ease,
    opacity 0.2s ease;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &:hover ${DragHandle}, &:hover ${MenuButton} {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
`;

/**
 * SectionAccordion - Renders a collapsible section with header and page list
 */
const SectionAccordion = ({
  expanded,
  onChange,
  isActive,
  isLocked,
  isMoving,
  lightColor,
  expandIcon,
  onContextMenu,
  headerContent,
  isCollapsed,
  children,
}) => {
  return (
    <StyledAccordion
      expanded={expanded}
      onChange={onChange}
      $active={isActive}
      $lightColor={lightColor}
      $isLocked={isLocked}
      $isMoving={isMoving}
      data-locked={isLocked}
    >
      <AccordionSummary expandIcon={!isLocked ? <Icon.ExpandMore /> : <Icon.Lock size='x-small' />} onContextMenu={onContextMenu}>
        <HeaderContent>{headerContent}</HeaderContent>
      </AccordionSummary>

      <AccordionDetails>
        <PageList $isCollapsed={isCollapsed}>{children}</PageList>
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default SectionAccordion;
